import React from 'react';
import { AlertTriangle, CheckCircle2 } from 'lucide-react';
import { parseFrNumber, formatFrNumber } from './docRectifConstants';

const PREFIX = 'territoires_ca.';
const num = (v) => {
  const n = parseFrNumber(v);
  return n === null || Number.isNaN(n) ? null : n;
};

// Total des territoires (valeurs actuelles + modifications) comparé au CA HT déclaré.
export const ControleTotalTerritoires = ({ edits, currentValues }) => {
  const lignes = {};
  Object.entries(currentValues).forEach(([k, v]) => {
    if (k.startsWith(PREFIX) && num(v)) lignes[k] = num(v);
  });
  const lignesEditees = Object.keys(edits).filter((k) => k.startsWith(PREFIX) && edits[k] !== '');
  const caEdit = num(edits['tarification.ca_ht'] ?? edits.chiffre_affaires);
  const ca = caEdit ?? num(currentValues['tarification.ca_ht']);
  if (!lignesEditees.length && caEdit !== null && Object.keys(lignes).length === 1) {
    lignes[Object.keys(lignes)[0]] = caEdit;
  }
  lignesEditees.forEach((k) => {
    const n = num(edits[k]) || 0;
    if (n > 0) lignes[k] = n; else delete lignes[k];
  });
  const total = Object.values(lignes).reduce((t, v) => t + v, 0);
  if (ca === null || !total) return null;
  const ecart = Math.round((total - ca) * 100) / 100;
  const ok = Math.abs(ecart) < 0.01;
  return (
    <div data-testid="ca-territoires-controle"
      className={`flex items-start gap-2 rounded border px-3 py-2 text-xs ${ok ? 'border-emerald-300 bg-emerald-50 text-emerald-800' : 'border-amber-400 bg-amber-50 text-amber-900'}`}>
      {ok ? <CheckCircle2 className="h-4 w-4 shrink-0" /> : <AlertTriangle className="h-4 w-4 shrink-0" />}
      <span>
        Total par territoire : <b>{formatFrNumber(total, 'money')}</b> — CA HT déclaré : <b>{formatFrNumber(ca, 'money')}</b>
        {ok ? ' — cohérent.' : ` — écart de ${formatFrNumber(ecart, 'money')}. Corrigez un territoire ou le CA HT.`}
      </span>
    </div>
  );
};
